
/**
 * CONTINAS CONTANTS ROUTES
 */

const ROUTES = {
  /**
   * General
   */
  DEFAULT: '/',
  HOME: '/',
  REGISTER: '/register',
  LOGOUT: '/logout',
  LOGIN: '/login',
  PRIVACY_POLICY: '/privacy-policy',
  HELP: '/help',
  CONTACT: '/contact-us',
  LOCK: '/lock',
  ERROR: '/error',

  /**
   * Pages
   */
  SPORTS: '/sports',
  UPCOMING: '/upcoming',
  FOOTBALL: '/football',
  BASEBALL: '/baseball',
  BASKETBALL: '/basketball',
  NBA: '/nba',
  PROMOTIONS: '/promotions',
  CASINO: '/casino',
  POKER: '/poker',
  BETXT_STANDALONE_URL: process.env.REACT_APP_BETXT_STANDALONE_URL || '',

  /**
   * Player
   */
  PLAYER: {
    MYBETS: '/player/mybets',
    PROFILE: '/player/profile',
    TICKET: {
      DETAIL: '/player/ticket/:ticket_id',
    }
  },

  /**
   * Shop
   */
  SHOP: {
    TICKET: {
      LIST: '/shop/tickets',
      DETAIL: '/shop/ticket/:ticket_id',
    }
  },

  VIRTUAL_SPORTS: '/virtual-sports',

  /**
   * Event route pattern (to be appended to sport routes)
   */
  EVENT: '/:league_slug/:event_description_slug/:event_id',
};

export default ROUTES;
